/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Cancel_SubscriptionInputs */

const en_plan_cancel_subscription = /** @type {(inputs: Plan_Cancel_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Subscription`)
};

const es_plan_cancel_subscription = /** @type {(inputs: Plan_Cancel_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar suscripción`)
};

/**
* | output |
* | --- |
* | "Cancel Subscription" |
*
* @param {Plan_Cancel_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_cancel_subscription = /** @type {((inputs?: Plan_Cancel_SubscriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Cancel_SubscriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_cancel_subscription(inputs)
	return en_plan_cancel_subscription(inputs)
});